export default "__VITE_ASSET__54922dbe__"